module.exports = __webpack_public_path__ + "static/media/kloa_home.bd903f78.png";